module.exports = __webpack_public_path__ + "static/img/6.-Instruction-Head.8712b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/6.-Instruction-Head.jpg
// module id = 43gO
// module chunks = 1